import React from 'react';
import ReactDOM from 'react-dom/client';
import { AlertProvider } from '@ascend/alert';
import { AppLockProvider } from './components/AppLock';
import { AppGate } from './AppGate';
import './styles/tokens.css';
import './styles/global.css';
import './styles/components.css';
import './styles/print.css';
import './styles/responsive.css';
import 'calc-controls/styles.css';
import '@ascend/about-modal/styles.css';
import '@ascend/alert/styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AlertProvider>
      <AppLockProvider>
        <AppGate />
      </AppLockProvider>
    </AlertProvider>
  </React.StrictMode>,
);


